import styled from 'styled-components'

export const OutlineContainer = styled.div`
display: flex;
gap: .75rem;
flex-direction: column;
`
